import { render } from "./NcrmWorkflowMailjetTelegramSettings.vue?vue&type=template&id=2d6ad0f4"
import script from "./NcrmWorkflowMailjetTelegramSettings.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowMailjetTelegramSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__